module.exports = __webpack_public_path__ + "img/logonovo.d5c39797.png";